import { Component, Inject } from '@angular/core';

import { APP_ENV, EnvironmentBase } from '@environments/environment.base';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NgForOf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { ReleaseNotes } from '@lib-ui/lib/components/release-notes/release-notes';

@Component({
  selector: 'lib-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    NgForOf,
    MatProgressSpinnerModule,
    MatButtonModule,
  ],
})
export class ReleaseNotesComponent {
  public releaseNotes = ReleaseNotes;


  constructor(
    @Inject(APP_ENV) private environment: EnvironmentBase,
    private dialogRef: MatDialogRef<ReleaseNotesComponent>,
  ) {
  }

  public getCurrentVersion() {
    return this.environment.version;
  }

  public Ok() {
    this.dialogRef.close(false);
  }
}
